// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kU-K4","placeholdersHeader":"styles_placeholdersHeader__YaRyO","editorStyle":"styles_editorStyle__2vOMe","placeholdersBox":"styles_placeholdersBox__2b53L"};